class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.menuItem = this.querySelector('.js-menu-item');

    this.menuItem.addEventListener('mouseover', (e) => {
      this.open(e.currentTarget);
    });

    this.menuItem.addEventListener('mouseleave', (e) => {
      this.close(e.currentTarget);
    });

    window.addEventListener("resize", this.adjustMegaMenuListOnResize.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)  - 4}px`);
  }

  open(el) {
    console.log('Opening menu...');
    el.setAttribute('open', true);
    el.querySelector('.js-menu-summary').setAttribute('aria-expanded', true);

    const menuList = this.querySelector("[js-megamenu-list]");

    if(menuList) {
      menuList.style.padding = `0 ${this.offsetLeft + 23}px`;
    }
  };
  
  close(el) {
    console.log('Closing menu...');
    el.removeAttribute('open');
    el.querySelector('.js-menu-summary').setAttribute('aria-expanded', false);
  };

  adjustMegaMenuListOnResize () {
    const menuList = this.menuItem.querySelector("[js-megamenu-list]");

    if(menuList) {
      menuList.style.padding = `0 ${this.menuItem.offsetLeft + 23}px`;
    }
  };

}

customElements.define('header-menu', HeaderMenu);
